import Vue from 'vue'
import Vuex from 'vuex'

import app from './modules/app/index.js'
import active from './modules/active/index.js'
import poster from './modules/poster/index'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app,
    active,
    poster
  }
})
